import type { DeviceModel } from '../../types/deviceModel';
import { rb5009uprModel } from './mikrotik-rb5009upr';
import { css610Model } from './mikrotik-css610';
import { rocketPrismAcModel } from './ubnt-rocket-prism-ac';
import { us16PoeModel } from './ubnt-us-16-poe';
import { injector24vModel, injector60wModel } from './injectors';
import { psu24vModel, psu48vModel, psu48v150Model } from './psus';
import { solar460Model, battery48v100ahModel, inverter5k48vModel, wallOutletAcModel } from './backupSources';
import { patchPanel24Model } from './patch-panel-24';

import { us8Model } from './ubnt-us-8';
import { us24PoeModel } from './ubnt-us-24-poe';
import { eap225Model } from './tplink-eap225';
import { u6LiteModel, u6LrModel, u6ProModel } from './ubnt-u6';

export const deviceModelCatalog: Record<string, DeviceModel> = {
  [rb5009uprModel.equipmentId]: rb5009uprModel,
  [css610Model.equipmentId]: css610Model,
  [rocketPrismAcModel.equipmentId]: rocketPrismAcModel,
  [us8Model.equipmentId]: us8Model,
  [us16PoeModel.equipmentId]: us16PoeModel,
  [us24PoeModel.equipmentId]: us24PoeModel,
  [injector24vModel.equipmentId]: injector24vModel,
  [injector60wModel.equipmentId]: injector60wModel,
  [psu24vModel.equipmentId]: psu24vModel,
  [psu48vModel.equipmentId]: psu48vModel,
  [psu48v150Model.equipmentId]: psu48v150Model,
  [solar460Model.equipmentId]: solar460Model,
  [battery48v100ahModel.equipmentId]: battery48v100ahModel,
  [inverter5k48vModel.equipmentId]: inverter5k48vModel,
  [wallOutletAcModel.equipmentId]: wallOutletAcModel,
  [patchPanel24Model.equipmentId]: patchPanel24Model,
  [eap225Model.equipmentId]: eap225Model,
  [u6LiteModel.equipmentId]: u6LiteModel,
  [u6LrModel.equipmentId]: u6LrModel,
  [u6ProModel.equipmentId]: u6ProModel,
};

export function getCatalogDeviceModel(equipmentId: string): DeviceModel | undefined {
  return deviceModelCatalog[equipmentId];
}

export { PSU_CATALOG } from './psus';
export {
  rb5009uprModel,
  css610Model,
  rocketPrismAcModel,
  us8Model,
  us16PoeModel,
  us24PoeModel,
  injector24vModel,
  injector60wModel,
  psu24vModel,
  psu48vModel,
  psu48v150Model,
  solar460Model,
  battery48v100ahModel,
  inverter5k48vModel,
  wallOutletAcModel,
  patchPanel24Model,
  eap225Model,
  u6LiteModel,
  u6LrModel,
  u6ProModel,
};
